import { useSelector } from "react-redux";
import { RootState } from "../redux/Store";

/**
 * Custom hook to check feature access
 */
export function useFeatureAccess() {
  const allowedFeatures = useSelector(
    (state: RootState) => state.featureAccess.allowedFeatures
  );

  /**
   * Check single feature access
   */
  const hasFeatureAccess = (featureDesc: string): boolean => {
    return allowedFeatures?.has(featureDesc?.trim()) ?? false;
  };

  /**
   * Filter list of options based on access
   */
  const filterByAccess = <T extends { label: string }>(
    options: T[],
    optionFeatureMap: Record<string, string>
  ): T[] => {
    return options.filter((opt) => {
      const featureDesc = optionFeatureMap[opt.label];
      return featureDesc && hasFeatureAccess(featureDesc);
    });
  };

  return { hasFeatureAccess, filterByAccess, allowedFeatures };
}
